/**
 * Chatbot Flow v2 API — Waba /api/chatbot-flows
 */
import apiClient from 'services/apiClient';

const unwrap = (res) => res?.data;

export const getFlows = (params = {}) =>
  apiClient.get('chatbot-flows', { params }).then(unwrap);

export const createFlow = (data) =>
  apiClient.post('chatbot-flows', data).then(unwrap);

export const getFlow = (id) =>
  apiClient.get(`chatbot-flows/${id}`).then(unwrap);

export const saveDefinition = (id, definition) =>
  apiClient.put(`chatbot-flows/${id}`, { definition }).then(unwrap);

export const patchFlow = (id, fields) =>
  apiClient.patch(`chatbot-flows/${id}`, fields).then(unwrap);

export const deleteFlow = (id) =>
  apiClient.delete(`chatbot-flows/${id}`).then(unwrap);

export const duplicateFlow = (id) =>
  apiClient.post(`chatbot-flows/${id}/duplicate`).then(unwrap);

export const publishFlow = (id, note) =>
  apiClient.post(`chatbot-flows/${id}/publish`, { note }).then(unwrap);

export const unpublishFlow = (id) =>
  apiClient.post(`chatbot-flows/${id}/unpublish`).then(unwrap);

export const validateFlow = (id) =>
  apiClient.post(`chatbot-flows/${id}/validate`).then(unwrap);

export const simulateFlow = (id, payload) =>
  apiClient.post(`chatbot-flows/${id}/simulate`, payload).then(unwrap);

export const getFlowSessions = (id, params = {}) =>
  apiClient.get(`chatbot-flows/${id}/sessions`, { params }).then(unwrap);

export const resetSession = (sessionId) =>
  apiClient.delete(`chatbot-flows/sessions/${sessionId}`).then(unwrap);

export const getActiveFlowForGroup = (groupId) =>
  apiClient.get(`chatbot-flows/groups/${groupId}/active`).then(unwrap);

/** Legacy chatbot groups */
export const getChatbotGroups = (userId) =>
  apiClient.get(`chatbot-groups/${userId}`).then(unwrap);

export const createChatbotGroup = (payload) =>
  apiClient.post('chatbot-groups', payload).then(unwrap);

export const updateChatbotGroup = (id, payload) =>
  apiClient.post(`chatbot-groups/${id}`, payload).then(unwrap);

export const deleteChatbotGroup = (groupId) =>
  apiClient.delete(`chatbot-group/${groupId}`).then(unwrap);

export const updateChatbotGroupStatus = (payload) =>
  apiClient.post('chatbot-groups-status', payload).then(unwrap);
